// 到处所有的工具类方法
export * from './utils';
import RichText from './index.vue';

export default RichText;
